import React from 'react';

import styles from './index.module.scss';
import Link from '../../../01_atoms/Link';
import { PTItemWithLogo, PTItemWithLogoDefaults } from './prop-types';

const ItemWithLogo = ({ name, nextLink, logoURL }) => {
  const content = (
    <div className="d-flex text-center flex-column-reverse text-md-left flex-md-row justify-content-md-between">
      <p className="align-self-center">
        <strong>{name}</strong>
      </p>

      {logoURL && (
        <div className="align-self-center image-container">
          <img src={logoURL} alt={name} width={140} height={80} />
        </div>
      )}
    </div>
  );
  return (
    <div className={`item-with-logo ${styles['item-with-logo']}`}>
      {nextLink && (
        <Link {...nextLink}>
          <a target="_blank" rel="noopener noreferrer">
            {content}
          </a>
        </Link>
      )}

      {!nextLink && <div className="content-wrapper">{content}</div>}
    </div>
  );
};

ItemWithLogo.propTypes = PTItemWithLogo.isRequired;
ItemWithLogo.defaultProp = PTItemWithLogoDefaults;

export default ItemWithLogo;
